import { Component, ElementRef, ViewChild } from '@angular/core';
import { BlockRadioBox, RadioItem } from '@src/app/@shared/models/step.model';
import { AbstractControl, FormBuilder, FormControl } from '@angular/forms';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

export enum FormControlName {
  items = 'items',
}

interface RadioForm {
  [FormControlName.items]: FormControl<RadioItem[]>;
}

@Component({
  selector: 'pl-block-radiobox',
  templateUrl: './block-radiobox.component.html',
})
export class BlockRadioboxComponent extends BlockAbstractComponent<BlockRadioBox, RadioForm> {
  protected FormControlName: typeof FormControlName = FormControlName;

  @ViewChild('plRadiobox', { read: ElementRef }) public plRadioboxElement!: ElementRef;

  protected override initForm(): void {
    const fb: FormBuilder = new FormBuilder();
    this.form = fb.nonNullable.group<RadioForm>({
      items: fb.nonNullable.control([]),
    });
  }

  protected override patchFormWithEmptyValue(): void {
    if (this.form) {
      this.form.patchValue(
        {
          [FormControlName.items]: [],
        },
        { emitEvent: false },
      );
    } else {
      throw new Error(`patchFormWithEmptyValue() this.form should not be null when this function is called`);
    }
  }

  protected override patchFormFromBlock(block: BlockRadioBox, valueFromLocalStorage: string | null): void {
    if (this.form) {
      let items: RadioItem[] = block.data.items;

      let markFormAsDirtyAndEmitValue: boolean = false;
      const isRadioItemSelected: boolean = items.some((item: RadioItem) => item.selected);
      if (!isRadioItemSelected && (block.data.value || valueFromLocalStorage)) {
        items = items.map((item: RadioItem): RadioItem => {
          return {
            ...item,
            selected: item.value === block.data.value || item.value === valueFromLocalStorage,
          };
        });
        markFormAsDirtyAndEmitValue = true;
        this.form.controls.items.markAsDirty();
      }

      this.form.patchValue(
        {
          items,
        },
        { emitEvent: markFormAsDirtyAndEmitValue },
      );
    } else {
      throw new Error(`patchFormFromBlock() this.form should not be null when this function is called`);
    }
  }

  protected override getUpdatedBlock(): BlockRadioBox {
    if (this.form && this.block) {
      const control: AbstractControl | null = this.form.get(FormControlName.items);
      if (control) {
        const value: string | null = this.extractValueFromItems(control.value);
        this.courseContentService.saveShortCodesInLocalStorage({ [this.block.program_data_code]: value });
        return {
          ...this.block,
          data: {
            ...this.block.data,
            items: control.value,
            value,
          },
        };
      }
    }

    throw new Error(`getUpdatedBlock() this.form or control should not be null when this function is called`);
  }

  private extractValueFromItems(items: RadioItem[]): string | null {
    return items.find((item: RadioItem) => item.selected)?.value || null;
  }

  protected override onProgrammaticFocus(): void {
    console.log('TONIO BlockRadioboxComponent onProgrammaticFocus =');
    // preventScroll: true because scroll is handled by directive plScrollToInvalidControlOnSubmit
    this.plRadioboxElement.nativeElement.focus({ preventScroll: true });
  }
}
